import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery, openKakaoLink } from '../../../utils';

export const OfflineInfo = () => {
  return (
    <Container>
      <Item>
        <FullTextContainer>
          <FullText>2026 TMT 19 ‘Main Event’ Day 1</FullText>
        </FullTextContainer>
        <TitleContainer>
          <img src={ImageUtils.ArrowRightIcon} />
          <Title>메인 이벤트 참가 티켓 소지자</Title>
        </TitleContainer>
        <Content>
          <LocationTitle>
            <span>ES Studio 수원</span>
          </LocationTitle>
          <LocationDesc>경기도 수원시 팔달구 인계로 94번길 27-27 2층</LocationDesc>
        </Content>

        <Content>
          <LocationTitle>1월 24일(토) 오후 1시 시작</LocationTitle>
          <LocationDesc>오후 12시 40분 부터 입장이 가능합니다.</LocationDesc>
        </Content>

        <WaringContainer>
          <WaringText>사용하지 않은 티켓은 이벤트 종료 후 소멸됩니다.</WaringText>
        </WaringContainer>

        <DetailContainer>
          <DetailText>
            자세한 내용은 <span onClick={openKakaoLink}>TMT 카카오톡 채널</span>에 문의해주세요!
          </DetailText>
        </DetailContainer>
      </Item>
    </Container>
  );
};

const FullTextContainer = styled.div`
  margin-bottom: 10px;
`;

const FullText = styled.h3`
  color: #00ffd4;
  font-size: 26px;
  line-height: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -1.04px;

  ${mobileQuery} {
    font-size: 18px;
  }
`;

const DetailContainer = styled.div`
  margin-top: 30px;
  padding-bottom: 30px;
  padding-top: 30px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);
  border-top: 1px solid rgba(112, 112, 112, 0.5);

  ${mobileQuery} {
    padding-top: 8px;
    margin-top: 8px;
    border-bottom: none;
  }
`;

const DetailText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;

  img {
    width: 7px;
    margin-right: 8px;
  }

  span {
    color: #fae100;
    font-size: 22px;
    font-weight: 600;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6.5%;
    text-underline-offset: 25%;
    text-underline-position: from-font;
    cursor: pointer;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 25px;
    text-align: left;

    img {
      height: 9px;
      margin-right: 5px;
    }
    span {
      font-size: 16px;
      line-height: 18px;
    }
  }
`;

const LocationTitle = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 18px;

    span {
      border-radius: 30px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      padding: 2px 10px;
      display: inline-block;
      margin-bottom: 4px;
    }
  }
`;

const LocationDesc = styled.h3`
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  ${mobileQuery} {
    font-size: 16px;
  }
`;

const Container = styled.div``;
const Item = styled.div`
  margin-bottom: 20px;

  ${mobileQuery} {
    margin-bottom: 10px;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  img {
    margin-right: 8px;
  }

  ${mobileQuery} {
    margin-bottom: 8px;
    img {
      width: 7px;
      margin-right: 4px;
      margin-bottom: 8px;
    }
  }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 24px;
  font-weight: 500;

  img {
    margin-right: 8px;
    margin-left: 8px;
  }
  ${mobileQuery} {
    font-size: 18px;
    line-height: 17px;
    margin-bottom: 10px;

    img {
      height: 10px;
      margin-right: 4px;
      margin-left: 4px;
    }
  }
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 25px;

  ${mobileQuery} {
    flex-direction: column;
    align-items: flex-start;
    padding-left: 16px;
    margin-bottom: 8px;
  }
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 30px;
  margin-top: 10px;

  ${mobileQuery} {
    padding-left: 10px;
  }
`;

const WaringText = styled.li`
  color: #8e8e8e;

  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.96px;
  position: relative;

  &:after {
    content: '';
    width: 6px;
    height: 6px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -20px;
    top: 10px;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 22px;

    &:after {
      width: 4px;
      height: 4px;
      left: -8px;
      top: 9px;
    }
  }

  span {
    color: white;
    text-decoration: underline;
  }
`;
